// extracted by mini-css-extract-plugin
module.exports = {"landingContainer":"Crypto_landingContainer__bRI3J","darkWrapper":"Crypto_darkWrapper__HqGpH","darkWrapper__twin":"Crypto_darkWrapper__twin__RaL2Y"};